import type { FunnelStatRow } from '@/entities/dropper-funnel';
import { milestoneLabel } from '@/entities/dropper-funnel';

interface DropperFunnelChartProps {
	buildId: string;
	funnel: FunnelStatRow[];
}

function formatRate(value: number | null): string {
	if (value == null) return '—';
	return `${Math.round(value * 100)}%`;
}

export default function DropperFunnelChart({ buildId, funnel }: DropperFunnelChartProps) {
	const baseline = funnel[0]?.count ?? 0;

	return (
		<div className='rounded-md border border-border bg-card p-3 grid gap-3'>
			<div>
				<h3 className='text-sm font-medium'>Воронка dropper</h3>
				<p className='text-xs text-muted-foreground'>Билд {buildId}</p>
			</div>
			{baseline === 0 ? (
				<p className='text-sm text-muted-foreground'>Нет событий dropper за выбранный период.</p>
			) : (
				<div className='grid gap-2'>
					{funnel.map(row => (
						<div key={row.name} className='grid gap-1'>
							<div className='flex items-center justify-between gap-2 text-xs'>
								<span className='truncate'>{milestoneLabel(row.name)}</span>
								<span className='shrink-0 text-muted-foreground'>
									{row.count} · {formatRate(row.rateFromStart)} от старта
								</span>
							</div>
							<div className='h-2 rounded-full bg-muted overflow-hidden'>
								<div
									className='h-full bg-chart-2 transition-all'
									style={{ width: `${Math.min(100, Math.round(row.rateFromStart * 100))}%` }}
								/>
							</div>
						</div>
					))}
				</div>
			)}
		</div>
	);
}
